<template>
  <div id="app">
    <router-view />
    <el-dialog
      title="催报通知"
      :visible.sync="detailDialogVisible"
      class="dialog68 titleChange bodyScroll"
      :close-on-click-modal="false"
    >
      <div style="margin-bottom: 15px; font-size: 16px">
        催报通知:
        <span style="dispaly: inline-block; padding: 3px 6px">{{ count }}</span
        >条
      </div>
      <div
        v-show="urgeToReports.length > 0"
        style="margin-bottom: 10px; font-size: 16px; font-weight: 600"
      >
        手动催报通知
      </div>
      <div v-for="item in urgeToReports" :key="item.id" class="urgeToReport">
        <p>
          <span>催报时间：</span>
          <span>{{ item.urgeDate }}</span>
        </p>
        <p class="urgeToReport_p">
          <span>催报信息：</span>
          <span>{{ item.message }}</span>
        </p>
      </div>
      <div style="height: 10px"></div>
      <div
        v-show="tbInsertGS.length > 0"
        style="margin-bottom: 10px; font-size: 16px; font-weight: 600"
      >
        系统催报通知
      </div>
      <div v-for="item in tbInsertGS" :key="item.id" class="urgeToReport">
        <p>
          <span>催报时间：</span>
          <span>{{ item.dateRangeEnd }}</span>
        </p>
        <p class="urgeToReport_p">
          <span>催报信息：</span>
          <span
            >尊敬的用户您好，您{{
              getDateRange(item.year, item.month, item.reportCycle)
            }}的{{ item.name }}数据还未上报，请及时处理，谢谢！</span
          >
        </p>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="suer()">确定</el-button>
        <el-button @click="detailDialogVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import globalVariable from "@/utils/global_variable.js";
import { Message } from "element-ui";
import { Header } from "element-ui";
import axios from "axios";
export default {
  data() {
    return {
      detailDialogVisible: false,
      userName: "",
      type: "",
      count: "",
      urgeToReports: "",
      tbInsertGS: "",
    };
  },
  methods: {
    getDateRange(year, month, cycle) {
      if (cycle == 0) {
        //月报
        return year + "年" + month;
      } else if (cycle == 1) {
        //季报
        if (month <= 3) {
          return `${year}年第一季度`;
        } else if (month >= 4 && month <= 6) {
          return `${year}年第二季度`;
        } else if (month >= 7 && month <= 9) {
          return `${year}年第三季度`;
        } else {
          return `${year}年第四季度`;
        }
      } else if (cycle == 2) {
        //半年报
        if (month <= 6) {
          return `${year}年上半年`;
        } else {
          return `${year}年下半年`;
        }
      } else {
        //年报
        return `${year}年`;
      }
    },
    //获取菜单树
    getMenuTree() {
      this.$axios
        .get("/system/menu/searchUserRoleMenuTree", { params: 0 })
        .then((res) => {
          this.$store.commit("setMenuTree", res.data);
        })
        .catch((res) => {});
    },
    //报表催报
    report() {
      this.$axios.get("/business/remind/remind").then((res) => {
        this.count = res.data.count;
        this.urgeToReports = res.data.tbUrgeToReports || [];
        this.tbInsertGS = res.data.tbInsertGS || [];
        if (res.data.count > 0) {
          this.detailDialogVisible = true;
        }
      });
    },
    getDepartment() {
      this.$axios.get("/system/feedback/selectUserInfo").then((res) => {
        sessionStorage.setItem("department", res.data.department);
        sessionStorage.setItem("name", res.data.name);
      });
    },
    //单点登录后获取用户信息
    login() {
      // if (
      //   sessionStorage.getItem("loginName") == "" ||
      //   sessionStorage.getItem("loginName") == null
      // ) {
      //   this.report();
      // }
      //自定一个信息用于方便开发  提交代码前注释
      // document.cookie = "userName=jjyxadmin@lygyhlw.com"; //用户名 管理员
      // document.cookie = "type=gly"; //用户类型 管理员
      // document.cookie = "userName=cservershow@163.com"; //用户名 政府
      // document.cookie = "type=zfyh"; //用户类型 政府
      // document.cookie = "userName=00017845145724"; //用户名  企业
      // document.cookie = "type=qyyh"; //用户类型 企业
      // document.cookie = "userName=yqgwh001"; //用户名  园区
      // document.cookie = "type=yqyh"; //用户类型 园区
      // document.cookie = "screen=t";
      // document.cookie = "dept=1";
      if (document.cookie) {
        let userMsg = document.cookie.split(";");
        for (let i = 0; i < userMsg.length; i++) {
          if (
            userMsg[i].split("=")[0] == "userName" ||
            userMsg[i].split("=")[0] == " userName"
          ) {
            this.userName = userMsg[i].split("=")[1];
            sessionStorage.setItem("loginName", userMsg[i].split("=")[1]);
          }
          if (
            userMsg[i].split("=")[0] == " type" ||
            userMsg[i].split("=")[0] == "type"
          ) {
            this.type = userMsg[i].split("=")[1];
            sessionStorage.setItem("userType", userMsg[i].split("=")[1]);
          }
          if (
            userMsg[i].split("=")[0] == " screen" ||
            userMsg[i].split("=")[0] == "screen"
          ) {
            this.type = userMsg[i].split("=")[1];
            sessionStorage.setItem("screen", userMsg[i].split("=")[1]);
          }
          if (
            userMsg[i].split("=")[0] == " dept" ||
            userMsg[i].split("=")[0] == "dept"
          ) {
            this.type = userMsg[i].split("=")[1];
            sessionStorage.setItem("dept", userMsg[i].split("=")[1]);
          }
          if (
            userMsg[i].split("=")[0] == " layout" ||
            userMsg[i].split("=")[0] == "layout"
          ) {
            this.type = userMsg[i].split("=")[1];
            sessionStorage.setItem("layout", userMsg[i].split("=")[1]);
          }
        }
        if (!this.userName || !this.type) {
          // window.location =
          //   "http://sso.cserver.com.cn/sso.web/login?layout=microbill";
          this.$axios
            .get(`system/config/selectConfigByKey?key=sso.login`)
            .then((result) => {
              console.log(result.data.data[0].value);
              window.location = result.data.data[0].value;
            });
          sessionStorage.removeItem("loginName");
          sessionStorage.removeItem("userType");
          sessionStorage.removeItem("screen");
          sessionStorage.removeItem("dept");
        }
        this.report();
        this.getDepartment();
      } else {
        // window.location =
        //   "http://sso.cserver.com.cn/sso.web/login?layout=microbill";
        this.$axios
          .get(`system/config/selectConfigByKey?key=sso.login`)
          .then((result) => {
            console.log(result.data.data[0].value);
            window.location = result.data.data[0].value;
          });
        sessionStorage.removeItem("loginName");
        sessionStorage.removeItem("userType");
        sessionStorage.removeItem("screen");
        sessionStorage.removeItem("dept");
      }
    },
    getAreaList() {
      // 区县列表
      this.$axios
        .get("/business/district/selectDistrictList")
        .then((res) => {
          this.$store.commit("setAreaLsit", res.data.data);
        })
        .catch((res) => {});
    },

    getAreaLists() {
      // 区县列表
      this.$axios
        .get("/business/district/selectDistrictList")
        .then((res) => {
          if (res) {
            this.$store.commit("setAreaLists", res.data.data);
          }
        })
        .catch((res) => {
          console.error("区县列表获取失败", res);
        });
    },
    getAreaListArr() {
      // 区县列表
      this.$axios
        .get("/business/district/selectCityNameList")
        .then((res) => {
          if (res.data.data) {
            this.$store.commit("setAreaListArr", res.data.data);
          }
        })
        .catch((res) => {
          console.error("区县列表获取失败", res);
        });
    },
    suer() {
      if (this.urgeToReports.length > 0) {
        this.$confirm("此操作将取消手动催报通知, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let id = [];
            this.urgeToReports.map((item) => {
              id.push(item.id);
            });
            this.$axios
              .put(`/business/remind/updateStstusByIds`, id)
              .then((res) => {
                this.detailDialogVisible = false;
              });
          })
          .catch(() => {
            console.error("取消");
          });
      }
      this.detailDialogVisible = false;
    },
  },
  created() {
    this.login();
    this.getMenuTree();
    console.log(1232);
    this.getAreaList();
    this.getAreaLists();
    this.getAreaListArr();
  },
};
</script>
<style>
@media (max-width: 1200px) {
  .dialog68 .el-dialog {
    width: 94% !important;
  }
}

@import url("/assets/styles/elementUI.css");
</style>
<style lang="less">
@import url("../src/assets/styles/global.less");
@import url("../src/assets/styles/element_ui_reset.less");

#app {
  width: 100%;
  height: 100%;
}

#app::-webkit-scrollbar {
  display: none;
}

.urgeToReport {
  border: 1px solid rgba(155, 155, 155, 0.2);
  margin-bottom: 10px;
  padding: 5px;
}
</style>